import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPeople: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPeople"><Path d="M16 6.5C16 8.70914 14.2091 10.5 12 10.5C9.79086 10.5 8 8.70914 8 6.5C8 4.29086 9.79086 2.5 12 2.5C14.2091 2.5 16 4.29086 16 6.5Z" stroke="currentColor" strokeLinejoin="round"/><Path d="M12 12.5C7.58172 12.5 4 16.0817 4 20.5H20C20 16.0817 16.4183 12.5 12 12.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconPeople;
